export default __webpack_public_path__ + "static/media/bank-detail.0ba5ccae.svg";